<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :sort-options="{
        enabled: true,
      }"
      styleClass="vgt-table bordered"
      :pagination-options="{
        enabled: true,
        mode: 'registros',
        position: 'top',
        perPage: 15,
        nextLabel: 'siguiente',
        prevLabel: 'anterior',
        rowsPerPageLabel: 'Filas por página',
        ofLabel: 'de',
        pageLabel: 'páginas', // for 'pages' mode
        allLabel: 'Todos',
      }"
    />
  </div>
</template>
<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'

export default {
  components: {
    VueGoodTable
  },
  data () {
    return {
      columns: [
        {
          label: 'No. empleado',
          width: '130px',
          type: 'number',
          field: 'EnterpriseUserNumber',
          filterOptions: {
            placeholder: 'No. de empleado',
            enabled: true
          }
        },
        {
          label: 'Nombre',
          field: 'UserName',
          filterOptions: {
            placeholder: 'Nombre',
            enabled: true
          }
        },
        {
          label: 'Empresa',
          field: 'EnterprisenAME',
          filterOptions: {
            placeholder: 'Empresa',
            enabled: true
          }
        },
        {
          label: 'NSS',
          field: 'NSS',
          width: '140px',
          filterOptions: {
            placeholder: 'NSS',
            enabled: true
          }
        },
        {
          label: 'CURP',
          field: 'CURP',
          filterOptions: {
            placeholder: 'CURP',
            enabled: true
          }
        },
        {
          label: 'RFC',
          field: 'RFC',
          width: '150px',
          filterOptions: {
            placeholder: 'RFC',
            enabled: true
          }
        },
        {
          label: 'Phone',
          field: 'Phone',
          width: '150px',
          filterOptions: {
            placeholder: 'Teléfono',
            enabled: true
          }
        },
        {
          label: 'Email',
          field: 'Email',
          filterOptions: {
            placeholder: 'Email',
            enabled: true
          }
        }
      ],
      rows: []
    }
  },
  async mounted () {
    try {
      const response = await axiosAdelaService.post('/getReportUsers', JSON.stringify({}))
      if (response.status === 200) {
        this.rows = response.data
      }
    } catch (error) {
      this.showError('No se pudieron obtener el reporte intentalo mas tarde.')
    }
  }
}
</script>
